import React from 'react';
import { DisplayErrorTemplate } from 'themes/modules/root/pages';
import { inject, observer } from 'mobx-react';

@inject(i => ({ rootStore: i.rootStore }))
@observer
class DisplayError extends React.Component {
	constructor(props) {
		super(props);
		const {
			rootStore: { errorStore },
		} = props;
		this.errors = errorStore.errors;
	}
	render() {
		return <DisplayErrorTemplate errors={this.errors} />;
	}
}

export default DisplayError;



// WEBPACK FOOTER //
// ./src/modules/root/pages/DisplayError.jsx